import StylePatternProperty from "./StylePattern";

export default function SharedProperties({ type }) {
  return <StylePatternProperty name={type} isFromShared />
}
